import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        ['pago', 'mensalidade', 'prorata'].forEach(item => {
            if (!data[item]){
                data[item] = 0;
            }
            else{
            data[item] = parseInt(data[item]);
            }
        });

        ['data_vencimento', 'data_pagamento'].forEach(item => {
            if (data[item]) {
                data[item] = new Date(data[item] + "T00:00:00");
            }
        });

        // Deriva tipo_conta a partir de mensalidade e prorata (somente para contas existentes)
        if (data.id) {
            if (data.mensalidade === 1) {
                data.tipo_conta = 'mensalidade';
            } else if (data.prorata === 1) {
                data.tipo_conta = 'prorata';
            } else {
                data.tipo_conta = 'avulso';
            }
        }
        // Para novas contas (sem id), tipo_conta permanece undefined/null

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/list${params}`, Token.getHeader());
    },
    listContas(contas, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/listContas/${contas}${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/conta/download${params}`, headers);
    },
    total(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/total${params}`, Token.getHeader());
    },
    valorTotal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/valor-total${params}`, Token.getHeader());
    },
    valorMensal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/conta/valor-mensal${params}`, Token.getHeader());
    },
    create(params) {
        return axios.post(`/api/conta`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/conta/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/conta/${id}`, Token.getHeader());
    },
}
